import { LiveClassDto, LiveClassServiceDto } from '../shared/types/LiveClassDto';
import { dateArrayToZonedDate, SERVER_TIME_ZONE } from '../shared/date-utils';

export class LiveClassHelpers {
  static convertArrayToDate(value: number[]) {
    if (!value || value.length > 7) {
      return;
    }
    const date = dateArrayToZonedDate(value, SERVER_TIME_ZONE);
    return date ? date.getTime() : undefined;
  }

  static convertLiveClassesArrayToDate(liveClassSchedules: Array<LiveClassServiceDto>): Array<LiveClassDto> {
    return liveClassSchedules.map((liveClassSchedule: LiveClassServiceDto) => {
      return {
        ...liveClassSchedule,
        classBegin: LiveClassHelpers.convertArrayToDate(liveClassSchedule.classBegin),
        classEnd: LiveClassHelpers.convertArrayToDate(liveClassSchedule.classEnd),
      };
    });
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class.helpers.ts